import { render, staticRenderFns } from "./YoutubeElement.vue?vue&type=template&id=7922f00d&scoped=true&"
import script from "./YoutubeElement.vue?vue&type=script&lang=js&"
export * from "./YoutubeElement.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeElement.vue?vue&type=style&index=0&id=7922f00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922f00d",
  null
  
)

export default component.exports